const FAKE_FUNCTION = () => void 0;

export { FAKE_FUNCTION };
//# sourceMappingURL=common.js.map
